import LineChart from '../components/LineChart';
import MetricCard from '../components/MetricCard';
import PageHeader from '../components/PageHeader';
import SectionCard from '../components/SectionCard';
import {
  approvalsByStatus,
  averageTenureYears,
  departmentsSummary,
  monthlyHireTrend
} from '../data/mockHelpers';
import { employees } from '../data/mock';
import DashboardLayout from '../components/DashboardLayout';
import { dashboardSidebar, dashboardUser, type BusinessPageProps } from './dashboardSidebar';

function AnalyticsPage(props: BusinessPageProps) {
  const departments = departmentsSummary();
  const totalEmployees = employees.filter((e) => e.status !== '离职').length;
  const pending = approvalsByStatus().pending.length;
  const trend = monthlyHireTrend();

  return (
    <DashboardLayout
      sidebar={dashboardSidebar}
      user={dashboardUser}
      pageTitle={{ heading: '数据分析', sub: '' }}
      metrics={[]}
      chart={{ title: '', data: [], xLabels: [] }}
      quickAccess={[]}
      activeSidebarId="analytics"
      omitPageTitle
      settingsPanel={props.settingsPanel}
      mobileMenu={props.mobileMenu}
      sidebarOpen={props.sidebarOpen}
    >
      <PageHeader heading="数据分析" sub="员工与组织结构全景(过去 12 个月)" />
      <div className="axi-section">
        <div className="axi-metric-grid">
          <MetricCard label="总员工" value={String(totalEmployees)} unit="人" icon="users" />
          <MetricCard label="部门数" value={String(departments.length)} unit="个" icon="bar" neutral />
          <MetricCard label="平均司龄" value={String(averageTenureYears())} unit="年" icon="clock" neutral />
          <MetricCard label="待审批" value={String(pending)} unit="条" icon="document" neutral />
        </div>
      </div>
      <SectionCard title="部门构成" description="按部门统计在职员工数">
        <ul className="axi-settings-list">
          {departments.map((d) => (
            <li key={d.id} className="axi-settings-list__row">
              <span className="axi-settings-list__label">
                {d.name} · 负责人 {d.manager}
              </span>
              <span className="axi-settings-list__value">{d.headcount} 人</span>
            </li>
          ))}
        </ul>
      </SectionCard>
      <SectionCard title="员工入职趋势" description="过去 12 个月每月新入职人数">
        <LineChart
          title="月度入职"
          data={trend.map((t) => t.count)}
          xLabels={trend.map((t) => t.label)}
          yMax={6}
        />
      </SectionCard>
    </DashboardLayout>
  );
}

export default AnalyticsPage;